import { GetServerSideProps } from 'next';
import React from 'react';
import { apiRequest } from '../../../components/util/requests/requests';
import Layout from '../../../components/Layout/Layout';
import { PageProps } from '../../../components/Models/PageProps';
import RenderSolution from '../../../components/util/RenderSolutions/Solution/RenderSolution';
import LargeWidthContainer from '../../../components/Layout/Containers/LargeWidthContainer';
import BreadcrumbsComponent from '../../../components/Breadcrumbs/BreadcrumbsComponent';

export const getServerSideProps: GetServerSideProps = async (context) => {
    const pageMetadata = await apiRequest(
        '/solutions?filters[solution]=INSURANCE_SOLUTION_QUOTING&populate[seo][populate]=*'
    );

    const pageInformation = await apiRequest(
        '/solutions?filters[solution]=INSURANCE_SOLUTION_QUOTING&populate[coverImage][populate]=*&populate[introduction][populate]=*'
    );

    const overviewSolutionsData = await apiRequest(
        '/solutions?filters[solution]=INSURANCE_OVERVIEW&populate[solutions][populate]=*'
    );

    const keywordsForRelatedResources =
        pageInformation.data &&
        pageInformation.data.length > 0 &&
        pageInformation.data[0].keywordsForRelatedResources
            ? pageInformation.data[0].keywordsForRelatedResources.split(',')
            : [];

    const queryStringToGetRelatedArticles = keywordsForRelatedResources
        .map((type, index) => {
            return `filters[$or][${index}][hashTags][$contains]=${type.trim()}`;
        })
        .join('&');

    const relatedArticles =
        keywordsForRelatedResources.length > 0
            ? await apiRequest(
                  `/resources?${queryStringToGetRelatedArticles}&populate[0]=mainImage&pagination[pageSize]=3`,
                  true
              )
            : [];

    return {
        props: {
            pageMetadata:
                pageMetadata.data && pageMetadata.data.length > 0 ? pageMetadata.data[0] : null,
            content:
                pageInformation.data && pageInformation.data.length > 0
                    ? pageInformation.data[0]
                    : null,
            overviewSolutions:
                overviewSolutionsData.data && overviewSolutionsData.data.length > 0
                    ? overviewSolutionsData.data[0]
                    : { solutions: [] },
            relatedArticles:
                relatedArticles.data && relatedArticles.data.length > 0 ? relatedArticles.data : [],
        },
    };
};

const crumbs = [
    {
        url: '',
        name: 'Products',
    },
    {
        url: '/solutions',
        name: 'Insurance Solutions',
    },
    {
        url: '/solutions/quoting',
        name: 'Quoting',
    },
];

const Quoting = ({ pageMetadata, content, overviewSolutions, relatedArticles }: PageProps) => {
    return (
        <Layout
            seoMetadata={pageMetadata?.seo}
            defaultMetaTitle={'Noria.no - Insurance Solutions - Quoting'}
        >
            <RenderSolution
                page={content}
                solutions={overviewSolutions.solutions}
                solutionKey={'INSURANCE_SOLUTION_QUOTING'}
                relatedArticles={relatedArticles}
            >
                <LargeWidthContainer>
                    <BreadcrumbsComponent crumbs={crumbs} />
                </LargeWidthContainer>
            </RenderSolution>
        </Layout>
    );
};

export default Quoting;
